import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useRouter } from 'next/router'

import PostTest from 'app/PelatihanMandiriPage/pages/PostTest'
import { CustomErrorFallback } from 'components/ErrorBoundary'
import PostTestErrorFallback, {
  PostTestCommonError,
  PostTestContentNotAvailable,
} from 'app/PelatihanMandiriPage/PostTest/PostTestErrorBoundary'
import { WithLayoutListener } from 'components/Layout/Desktop/DesktopLayout'

const PostTestPage = (props) => {
  const { isDesktopScreenSize } = props
  const router = useRouter()

  return (
    <ErrorBoundary
      resetKeys={[router.asPath]}
      FallbackComponent={({ error, resetErrorBoundary }) => {
        if (
          error instanceof PostTestContentNotAvailable ||
          error instanceof PostTestCommonError
        ) {
          return (
            <PostTestErrorFallback
              error={error}
              resetErrorBoundary={resetErrorBoundary}
            />
          )
        } else {
          return (
            <CustomErrorFallback
              error={error}
              resetErrorBoundary={resetErrorBoundary}
            />
          )
        }
      }}
    >
      <WithLayoutListener isDesktop={isDesktopScreenSize}>
        <PostTest />
      </WithLayoutListener>
    </ErrorBoundary>
  )
}

PostTestPage.layoutOpts = {
  className: 'text-default',
  hasHeader: true,
  enableDesktopLayout: true,
}

export default PostTestPage
